export default "__VITE_ASSET__9db58027__"